import { APICall } from ".";

export const ax_analytics_fetchAnalytics = async () => {
  try {
    const { data } = await APICall.get("/analytics");

    // console.log("Analytics response status:", data.code, data.success);

    if (data.code === 200 || !data.success) {
      return data;
    }
    return null;
  } catch (error) {
    console.error("Error while fetching analytics:", error);
    return null;
    // throw error; // Re-throw error if needed to propagate it upwards
  }
};
